import React, { useCallback, useEffect, useState } from 'react';
import { Dropdown, ListGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ChatList from './ChatList';
// import { API_SERVER } from '../../../../config/constant';
import { toast } from 'react-toastify';
import avatar1 from '../../../../assets/images/user/avatar-2.jpg';
import SearchableDropdown from '../../../../components/Form/SearchableDropdown';
import { LOGOUT } from './../../../../store/actions';
// import avatar2 from '../../../../assets/images/user/avatar-2.jpg';
// import avatar3 from '../../../../assets/images/user/avatar-3.jpg';
// import avatar4 from '../../../../assets/images/user/avatar-4.jpg';
const NavRight = () => {
    const [selectedProject, setSelectedProject] = useState(null);
    const [data, setData] = useState([]);
    const dispatcher = useDispatch();

    const account = useSelector((state) => state.account);
    const { user } = account;
    const userProjectData = user?.user?.projectsList;
    const userData = user?.user;

    const [listOpen, setListOpen] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('token');
        dispatcher({ type: LOGOUT });
    };
    const getSelectedOption = useCallback((option) => {
        setSelectedProject(option);
    }, []);
    // const fetchProjectData = async () => {
    //     try {
    //         const response = await fetchProject();
    //         let pro = response?.data?.map((project) => ({
    //             value: project.id,
    //             label: `${project.projectName} `
    //         }));
    //         setData(pro);
    //         // if (Array.isArray(response.data)) {
    //         //     setData(response.data);
    //         // } else if (Array.isArray(response)) {
    //         //     setData(response);
    //         // }
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };
    // useEffect(() => {
    //     fetchProjectData();
    // }, []);

    const projectData = (dataArray) => {
        return dataArray.map((item) => ({ value: item.id, label: item.name }));
    };
    useEffect(() => {
        const selectProject = localStorage.getItem('selectedProject');
        setSelectedProject(selectProject);
    }, [selectedProject]);
    // useEffect(() => {
    //     localStorage.removeItem('selectedProject');
    // }, [handleLogout]);
    return (
        <React.Fragment>
            <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto" id="navbar-right">
                {/* <ListGroup.Item as="li" bsPrefix=" ">
                    <Dropdown>
                        <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
                            <i className="feather icon-bell icon" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight className="notification notification-scroll">
                            <div className="noti-head">
                                <h6 className="d-inline-block m-b-0">Notifications</h6>
                                <div className="float-right">
                                    <Link to="#" className="m-r-10">
                                        mark as read
                                    </Link>
                                    <Link to="#">clear all</Link>
                                </div>
                            </div>
                            <PerfectScrollbar>
                                <ListGroup as="ul" bsPrefix=" " variant="flush" className="noti-body">
                                    <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                                        <p className="m-b-0">NEW</p>
                                    </ListGroup.Item>
                                    <ListGroup.Item as="li" bsPrefix=" " className="notification">
                                        <Media>
                                            <img className="img-radius" src={avatar1} alt="Generic placeholder" />
                                            <Media.Body>
                                                <p>
                                                    <strong>John Doe</strong>
                                                    <span className="n-time text-muted">
                                                        <i className="icon feather icon-clock m-r-10" />
                                                        30 min
                                                    </span>
                                                </p>
                                                <p>New ticket Added</p>
                                            </Media.Body>
                                        </Media>
                                    </ListGroup.Item>
                                    <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                                        <p className="m-b-0">EARLIER</p>
                                    </ListGroup.Item>
                                    <ListGroup.Item as="li" bsPrefix=" " className="notification">
                                        <Media>
                                            <img className="img-radius" src={avatar2} alt="Generic placeholder" />
                                            <Media.Body>
                                                <p>
                                                    <strong>Joseph William</strong>
                                                    <span className="n-time text-muted">
                                                        <i className="icon feather icon-clock m-r-10" />
                                                        30 min
                                                    </span>
                                                </p>
                                                <p>Purchase New Theme and make payment</p>
                                            </Media.Body>
                                        </Media>
                                    </ListGroup.Item>
                                    <ListGroup.Item as="li" bsPrefix=" " className="notification">
                                        <Media>
                                            <img className="img-radius" src={avatar3} alt="Generic placeholder" />
                                            <Media.Body>
                                                <p>
                                                    <strong>Sara Soudein</strong>
                                                    <span className="n-time text-muted">
                                                        <i className="icon feather icon-clock m-r-10" />
                                                        30 min
                                                    </span>
                                                </p>
                                                <p>currently login</p>
                                            </Media.Body>
                                        </Media>
                                    </ListGroup.Item>
                                    <ListGroup.Item as="li" bsPrefix=" " className="notification">
                                        <Media>
                                            <img className="img-radius" src={avatar4} alt="Generic placeholder" />
                                            <Media.Body>
                                                <p>
                                                    <strong>Suzen</strong>
                                                    <span className="n-time text-muted">
                                                        <i className="icon feather icon-clock m-r-10" />
                                                        yesterday
                                                    </span>
                                                </p>
                                                <p>Purchase New Theme and make payment</p>
                                            </Media.Body>
                                        </Media>
                                    </ListGroup.Item>
                                </ListGroup>
                            </PerfectScrollbar>
                            <div className="noti-footer">
                                <Link to="#">show all</Link>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </ListGroup.Item> */}
                {/* <ListGroup.Item as="li" bsPrefix=" ">
                    <Dropdown>
                        <Dropdown.Toggle as={Link} variant="link" to="#" className="displayChatbox" onClick={() => setListOpen(true)}>
                            <i className="icon feather icon-mail" />
                        </Dropdown.Toggle>
                    </Dropdown>
                </ListGroup.Item> */}
                <ListGroup.Item as="li" bsPrefix=" " className="d-flex flex-row align-items-center " style={{ gap: '8px' }}>
                    {/* <Row>
                        <Col className="" md={12} sm={6} style={{ lineHeight: '12px' }}> */}
                    {/* <div
                        style={{
                            lineHeight: '12px',
                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
                        }}
                    > */}
                    {/* {userProjectData.length > 1 ? (
                        <SearchableDropdown
                            options={projectData(userProjectData)}
                            selectedOptions={selectedProject?.id ? selectedProject : null}
                            placeholder={'Select Project'}
                            setSelectedOptions={getSelectedOption}
                        />
                    ) : (
                        <div
                            className="d-flex align-items-center "
                            style={{
                                lineHeight: '0px'
                            }}
                        >
                            <p>{projectData(userProjectData)[0]?.label}</p>
                        </div>
                    )} */}
                    {/* </div> */}

                    {/* </Col>
                    </Row> */}
                    {/* <ListGroup.Item
                        className="border-none bg-none rounded"
                        style={{
                            border: 'none',
                            // backgroundColor: 'transparent'
                            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
                            padding: '10px 5px'
                        }}
                    >
                        {user.role === 'admin' ? (
                            <div
                                style={{
                                    lineHeight: '12px',
                                    padding: '0px',
                                    minWidth: '150px'
                                    // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
                                }}
                                // className="text-primary"
                            >
                                <SearchableDropdown
                                    options={data}
                                    // selectedOptions={selectedProject?.id ? selectedProject : null}
                                    placeholder={selectedProject ? selectedProject : 'Select Project'}
                                    setSelectedOptions={getSelectedOption}
                                />
                            </div>
                        ) : (
                            <div style={{ lineHeight: '12px' }}>{projectData(userProjectData)[0]?.label}</div>
                        )}
                    </ListGroup.Item> */}
                    <Dropdown className="drp-user">
                        <Dropdown.Toggle as={Link} variant="link" id="dropdown-basic">
                            <i className="icon feather icon-settings" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight className="profile-notification">
                            <div className="pro-head">
                                <img src={avatar1} className="img-radius" alt="User Profile" />
                                <span className="text-uppercase">
                                    {user?.first_name} {user?.last_name}
                                </span>
                                <Link className="dud-logout" onClick={handleLogout} title="Logout">
                                    <i className="feather icon-log-out" />
                                </Link>
                            </div>
                            {/* <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body">
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item">
                                        <i className="feather icon-settings" /> Settings
                                    </Link>
                                </ListGroup.Item>
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item">
                                        <i className="feather icon-user" /> Profile
                                    </Link>
                                </ListGroup.Item>
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item">
                                        <i className="feather icon-mail" /> My Messages
                                    </Link>
                                </ListGroup.Item>
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item">
                                        <i className="feather icon-lock" /> Lock Screen
                                    </Link>
                                </ListGroup.Item>
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item" onClick={handleLogout}>
                                        <i className="feather icon-log-out" /> Logout
                                    </Link>
                                </ListGroup.Item>
                            </ListGroup> */}
                        </Dropdown.Menu>
                    </Dropdown>
                </ListGroup.Item>
            </ListGroup>
            <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
        </React.Fragment>
    );
};

export default NavRight;
